import React from "react";
import { useTranslation } from "react-i18next";
import { formatDollarAmount } from "../../../../utils/methods";

interface TableHeaderSectionProps {
  total: number;
  kpis: any;
}

const TableHeaderSection: React.FC<TableHeaderSectionProps> = ({ total, kpis }) => {
  const { t } = useTranslation();
  return (
    <div className="col-md-12 header-section-div">
      <div className="row">
        <div className="col-sm-12 px-3 py-5 d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <i className="ri-exchange-dollar-line ri-22px"></i>
            <h5 className="mx-3 my-0">{t('transactions.list.pageTexts.table.title')} ({total})</h5>
          </div>
          <div className="d-flex align-items-center">
            <span className="me-1 fw-semibold">{t("transactions.list.pageTexts.table.unbilled")}:</span>
            <span className="badge bg-secondary me-2">{kpis.unbilledCount}</span>

            <span className="mx-2">|</span>

            <span className="me-1 fw-semibold">{t("transactions.list.pageTexts.table.invoiced")}:</span>
            <span className="badge bg-warning me-2">{kpis.invoicedCount}</span>

            <span className="mx-2">|</span>

            <span className="me-1 fw-semibold">{t("transactions.list.pageTexts.table.settled")}:</span>
            <span className="badge bg-info me-2">{kpis.settledCount}</span>

            <span className="mx-2">|</span>

            <span className="me-1 fw-semibold">{t("transactions.list.pageTexts.table.debits")}:</span>
            <span className="badge bg-primary me-2">{kpis.totalDebitsAmount ? formatDollarAmount(kpis.totalDebitsAmount) : '-'}</span>

            <span className="mx-2">|</span>

            <span className="me-1 fw-semibold">{t("transactions.list.pageTexts.table.credits")}:</span>
            <span className="badge bg-success">{kpis.totalCreditsAmount ? formatDollarAmount(kpis.totalCreditsAmount) : '-'}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TableHeaderSection;